import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { SingleDatePicker } from 'react-dates'
import moment from 'moment'
import _ from 'lodash'
import 'react-dates/lib/css/_datepicker.css'

moment.locale('pt-br')

const DatePicker = ({date, disabled,
  focused,
  isOutsideRange,
  onDateChange,
  onChange,
  onFocusChange,
  placeholder,
  showClearDate,
  value,
  id,
  scrollIntoView = true,
  openUp}) => {
  const [focusedState, setFocused] = useState(false)
  const dateRef = useRef(null)

  const handleChange = (value) => {

    if (onChange) {
      return onChange({
        target: { value },
      })
    }
    onDateChange && onDateChange(value)
  }

    const handleFocusChange = (data) => {
      if (data.focused && scrollIntoView) {
        setTimeout(() => {
          dateRef.scrollIntoView({ behavior: 'smooth' })
        }, 100)
      }

      if(onFocusChange) return onFocusChange(data)

      setFocused(data.focused)

    }

    const isFocused = () => _.isNil(focused) ? focusedState : focused

    const isOutsideRangeState = () => {
      if (_.isFunction(isOutsideRange)) return isOutsideRange

      return isOutsideRange && (() => false)
    }

    return (
      <SingleDatePicker
        ref={dateRef}
        placeholder={placeholder}
        date={date || value || null}
        focused={isFocused()}
        onDateChange={handleChange}
        onFocusChange={handleFocusChange}
        numberOfMonths={1}
        hideKeyboardShortcutsPanel
        displayFormat={() => moment.localeData('pt-br').longDateFormat('L')}
        monthFormat='MMMM YYYY'
        readOnly
        disabled={disabled}
        showClearDate={showClearDate}
        isOutsideRange={isOutsideRangeState()}
        id={id}
        openDirection={openUp}
      />
    )
}

DatePicker.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disabled: PropTypes.bool,
  focused: PropTypes.bool,
  isOutsideRange: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  onDateChange: PropTypes.func,
  onChange: PropTypes.func,
  onFocusChange: PropTypes.func,
  placeholder: PropTypes.string,
  showClearDate: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  id: PropTypes.string,
  scrollIntoView: PropTypes.bool.isRequired,
  openUp: PropTypes.string,
}

export default DatePicker
